import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, storeActions } from '../../../store'
import { CurrentSubView } from '../../../models/enums'
import Mobile from './Mobile'
import ParametersAndDashboardContainer from './ParametersAndDashboardContainer'

interface MobileContainerProps {
  hideMenu: boolean
}

const MobileContainer = ({ hideMenu }: MobileContainerProps): JSX.Element => {
  const dispatch = useDispatch()
  const dashboardOpened = useSelector((state: RootState) => state.utilsReducer.dashboardOpened)

  const toggleParameters = (): void => {
    dispatch(storeActions.utils.setCurrentSubView(CurrentSubView.none))
    dispatch(storeActions.utils.setDashboardOpened(!dashboardOpened))
  }

  return (
    <React.Fragment>
      {/* Menu */}
      <div id='retorik-framework-mobile-menu-container' className='rf-absolute rf-bottom-0 rf-w-full rf-h-fit rf-flex rf-flex-col-reverse rf-z-[4] rf-bg-transparent'>
        <Mobile parametersOpened={dashboardOpened} toggleParameters={toggleParameters} />
      </div>

      {/* Parameters */}
      {dashboardOpened && <ParametersAndDashboardContainer handleBack={toggleParameters} hideMenu={hideMenu} />}
    </React.Fragment>
  )
}

export default MobileContainer
